import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/btch/schd`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/btch/schds`,
    nodes: [],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    ptli1202001q: `${BASE.path}/ptli1202001q`, // Manage schedules list !== 스케줄관리 목록 ==!
    ptli1202002s: `${BASE.path}/ptli1202002s`, // Manage schedules registration !== 스케줄관리 등록 ==!
    ptli1202003s: `${BASE.path}/ptli1202003s`, // Manage schedules details !== 스케줄관리 수정 ==!
    ptli1202004q: `${BASE.path}/ptli1202004q`, // Manage schedules details !== 스케줄관리 상세 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // Select batch schedule list !== 배치 스케줄 목록 조회 ==!
    getBtchSchdList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // Select schedule parameter list !== 스케줄 파라미터 목록 조회 ==!
    getSchdPrmtList: (btchId: string) => api.get(`${BASE.api}/${btchId}/prmts`),

    // Save batch schedule information !== 배치 스케줄 정보 저장 ==!
    insertBtchInfo: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },

    // Select batch schedule information !== 배치 스케줄 정보를 조회한다.==!
    getBtchSchdInfo: (btchSchdId: any) => api.get(`${BASE.api}/${btchSchdId}`),

    // Update batch schedule information !== 배치 스케줄 정보 수정 ==!
    updateBtchSchdInfo: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },

    // Delete batch schedule information !== 배치 스케줄 정보 삭제 ==!
    deleteBtchSchdInfo: (hldyId: any) => api.delete(`${BASE.api}/${hldyId}`),
};

export const SF_BTCH_SCHD_SEARCH_FORM: TFormSchema = {
    id: "form_infoSrch",
    schema: {
        /* Business Type !== 업무 분류 ==!*/
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_NM",
            all: true,
            area: "comnCd",
            comnCd: "COM0024",
            excludes: ["TDW", "TDA"],
        },
        /* Search keyword Select Option !== 검색어 목록 ==!*/
        kwdSel: {
            type: "select",
            label: "L_KWD",
            options: [
                { label: "L_BTCH_NM", value: "A" },
                { label: "L_BTCH_SCHD_NM", value: "B" },
            ],
        },
        /* Search keyword Select Option Name !== 검색어 ==!*/
        kwdTxt: {
            type: "text",
            edit: true,
        },
    },
};

export const SF_BTCH_SCHD_FORM: TFormSchema = {
    id: "form_schdSrch",
    schema: {
        btchId: {
            type: "text",
            label: "L_BTCH_ID",
            required: true,
            edit: true,
            readOnly: true,
        } /* Batch ID !== 배치 ID ==!*/,
        btchNm: {
            type: "text",
            label: "L_BTCH_NM",
            required: true,
            edit: true,
            readOnly: true,
        } /* Job Name(Barch Name) !== Job 이름(배치명) ==!*/,
        btchSchdId: {
            type: "text",
            label: "L_BTCH_SCHD_ID",
            required: true,
            edit: true,
        } /* Schedules ID !== 스케줄 ID ==!*/,
        btchSchdNm: {
            type: "text",
            label: "L_BTCH_SCHD_NM",
            required: true,
            edit: true,
        } /* Schedules Name !== 스케줄명 ==!*/,
        excutnCycle: {
            type: "select",
            label: "L_EXCUTN_CYCLE",
            required: true,
            edit: true,
        } /* Execution Cycle !== 실행주기 ==!*/,
        frstRgsrDtm: {
            type: "text",
            label: "L_FRST_RGSR_DTM",
            edit: true,
        } /* Registration Date !== 등록 일자 ==!*/,
        excutnSchdDd: {
            type: "date",
            edit: true,
        } /* Batch Execution Date !== 일자 ==!*/,
        btchExcutnMm: {
            type: "select",
            edit: true,
        } /* Batch Execution Month !== 월 ==!*/,
        btchExcutnDwk: {
            type: "checkbox",
            edit: true,
        } /* Batch Execution Day of Week !== 요일 ==!*/,
        btchExcutnDay: {
            type: "select",
            edit: true,
        } /* Batch Execution Day !== 일 ==!*/,
        excutnSchdTime: {
            type: "select",
            edit: true,
        } /* Batch Execution Time !== 시간 ==!*/,
        excutnSchdMi: {
            type: "select",
            edit: true,
        } /* Batch Execution minute !== 분 ==!*/,
        excutnSchdSs: {
            type: "select",
            edit: true,
        } /* Batch Execution Second !== 초 ==!*/,
        btchExcutnTms: {
            type: "select",
            edit: true,
        } /* Batch Execution Time minute Second !== 시간 분 초 ==!*/,
        btchSchdCnxsValue: {
            type: "text",
            edit: true,
            label: "L_EXCUTN_CYCLE",
        },
        btchSchdTmsValue: {
            type: "text",
            pattern: { value: /[0-9]$/, message: "msg.ptl.00677" },
            edit: true,
        } /* Batch Execution Time minute Second value !== 시분초 값 ==!*/,
    },
};

export const SG_BTCH_SCHD_LIST: TGridSchema = {
    id: "grid_btchInfoList",
    options: { pagination: "out", edit: false, checkbox: false, radio: false, index: true },
    head: [
        // { cells: [{ header: "L_BTCH_ID", binding: "btchId", width: "15%" }], id: "btchId" },
        { cells: [{ header: "L_BTCH_NM", binding: "btchNm", width: "20%" }], id: "btchNm" },
        { cells: [{ header: "L_BSOP_CLSF_NM", binding: "bsopClsfCdNm", width: "15%" }], id: "bsopClsfCdNm" },
        { cells: [{ header: "L_BTCH_SCHD_ID", binding: "btchSchdId", width: "20%" }], id: "btchSchdId" },
        { cells: [{ header: "L_BTCH_SCHD_NM", binding: "btchSchdNm", width: "25%" }], id: "btchSchdNm" },
        { cells: [{ header: "L_EXCUTN_CYCLE", binding: "btchSchdCnxsValue", width: "10%" }], id: "btchCycleTpCd" },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "15%" }], id: "frstRgsrDtm" },
    ],
    body: [
        // {
        //     cells: [{ binding: "btchId" }] /* Batch ID !== 배치 ID ==!*/,
        // },
        {
            cells: [{ binding: "btchNm", align: "left" }] /* Job Name(Barch Name) !== Job 이름(배치명) ==!*/,
        },
        {
            cells: [{ binding: "bsopClsfCdNm" }] /* Business Type !== 업무 구분 ==!*/,
        },
        {
            cells: [{ binding: "btchSchdId" }] /* Schedules ID !== 스케줄 ID ==!*/,
        },
        {
            cells: [{ binding: "btchSchdNm", align: "left" }] /* Schedules Name !== 스케줄명 ==!*/,
        },
        {
            cells: [{ binding: "btchSchdCnxsValue", align: "left" }] /* Execution Cycle !== 실행주기 ==!*/,
        },
        {
            cells: [{ binding: "frstRgsrDtm", type: "datetime" }] /* Registration Date !== 등록 일자 ==!*/,
        },
    ],
};

export const SG_BTCH_SCHD_PRMT_LIST: TGridSchema = {
    id: "grid_btchSchdPrmtList",
    options: { pagination: "in", edit: true, checkbox: true, radio: false, index: false },
    head: [
        { cells: [{ header: "L_PRMT_NM", binding: "btchPrmtNm", width: "*" }], id: "btchPrmtNm" },
        { cells: [{ header: "L_PRMT", binding: "btchPrmtValue", width: "*" }], id: "btchPrmtValue" },
    ],
    body: [
        {
            cells: [{ binding: "btchPrmtNm" }] /* Parameter Name !== 파라미터명 ==!*/,
        },
        {
            cells: [{ binding: "btchPrmtValue" }] /* Parameter !== 파라미터 ==!*/,
        },
    ],
};
